import {
  Role
} from '@/helper/Role';
import {
  authenticationService
} from "@/services/AuthenticationService";

console.log('authenticationService :', authenticationService);

export default {
  items: [{
    name: 'Home',
    url: '/home',
    icon: 'icon-home',
    show: true,
    children: [{
      name: 'Home',
      url: '/home/homepage',
      icon: 'icon-arrow-right',

      description: '',
      show: true
    }
    ]
  },

  {
    name: 'reports',
    url: '/role-management',
    icon: 'icon-report',
    permissions: [Role.AnalyticsManager],
    children: [
      //   {
      //   name: 'summary',
      //   url: '/reports/summary',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.AnalyticsManager],
      // },
      // {
      //   name: 'performancereport',
      //   url: '/reports/performance-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.AnalyticsManager],
      // },
      {
        name: 'summary',
        url: '/mobile/reports/Summary',
        icon: 'icon-arrow-right',
        description: '',
        permissions: [Role.AnalyticsManager],
      },
      {
        name: 'dailysalesreport',
        url: '/mobile/reports/daily-Sales-report',
        icon: 'icon-arrow-right',
        description: '',
        permissions: [Role.AnalyticsManager],
      },
      {
        name: 'filmwisecollectionreport',
        url: '/mobile/reports/film-Wise-report',
        icon: 'icon-arrow-right',
        description: '',
        permissions: [Role.AnalyticsManager],
      },
      {
        name: 'screencollectionreport',
        url: '/mobile/reports/screen-Wise-report',
        icon: 'icon-arrow-right',
        description: '',
        permissions: [Role.AnalyticsManager],
      }


      // {
      //   name: 'filmwisecollectionreport',
      //   url: '/reports/film-wise-collection-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.AnalyticsManager],
      // },
      // {
      //   name: 'screencollectionreport',
      //   url: '/reports/screen-wise-collection-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.AnalyticsManager],
      // },
      // {
      //   name: 'distributorcollectionreport',
      //   url: '/reports/distributor-collection-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.AnalyticsManager],
      // },
      // {
      //   name: 'Distributor Share Report',
      //   url: '/reports/distributor-share-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [],
      // },
      // {
      //   name: 'aggregatorsTransactionReport',
      //   url: '/reports/aggregators-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.AnalyticsManager],
      // },
      // {
      //   name: 'aggregatorsDailySalesReport',
      //   url: '/reports/aggregator-daily-sales-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.AnalyticsManager],
      // },
      // //
      // {
      //   name: 'advancesalesreport',
      //   url: '/reports/advance-sales-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      // },
      // {
      //   name: 'hourlysphReport',
      //   url: '/reports/hourly-sph-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      // },
      // {
      //   name: 'recipeReport',
      //   url: '/reports/recipe-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      // },
      // {
      //   name: 'fastmovingreport',
      //   url: '/reports/fast-moving-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.SuperAdmin, Role.HoManager],
      // },
      // {
      //   name: 'concessiondailyReport',
      //   url: '/reports/concession-daily-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      // },
      // {
      //   name: 'cogsReport',
      //   url: '/reports/cogs-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      // },
      // {
      //   name: 'grnReport',
      //   url: '/reports/grn-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      // },
      // {
      //   name: 'stockwastageReport',
      //   url: '/reports/stock-wastage-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      // },
      // {
      //   name: 'currentStockReport',
      //   url: '/reports/current-stock-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      // },
      // {
      //   name: 'municipalityReport',
      //   url: '/reports/municipality-report',
      //   icon: 'icon-arrow-right',
      //   description: '',
      //   permissions: [Role.SuperAdmin, Role.HoManager, Role.CinemaManager],
      // }
    ]
  },





  ]
}



// WEBPACK FOOTER //
// ./src/NavMobile.js